import useReduxState from "./useReduxState";
import { useWallet } from "@solana/wallet-adapter-react";

export default function useUserLogout(): [() => Promise<void>] {
  const [, setUser] = useReduxState((state) => state.userData);
  const { wallet, disconnect } = useWallet();

  async function handleLogoutUser() {
    if (localStorage) {
      localStorage.removeItem("token");
    }

    if (wallet) {
      disconnect();
    }

    setUser({
      type: "RESET_USER_DATA",
      arg: null,
    });
  }

  return [handleLogoutUser];
}
